import FormsBaseField from "./forms-base-field.vue";

export default {
	mixins: [
		FormsBaseField
	],
    data() {
        return {
            doneTyping: false,
            doneTypingTimeout: 250,
            typingTimeout: null,
            userInput: this.field.value
        }
    },
    created() {
        this.addValidations();
    },
    watch: {
        userInput() {
            this.doneTyping = false;
            this.error = null;

            clearTimeout(this.typingTimeout);

            this.updateState(state => state.userTyping = true);

            this.typingTimeout = setTimeout(() => {
                this.doneTyping = true;

                this.validateField();
                this.updateState(state => state.userInput = this.userInput);
                this.updateState(state => state.userTyping = false);
            }, this.doneTypingTimeout);
        }
    },
    methods: {
        isLabelActive_() {
            return this.focused || this.userInput !== '';
        },
        addValidations() {
            this.addFieldValidation(validation => {
                if ("maxLength" in validation
                    && validation.maxLength > -1
                    && this.userInput.length > validation.maxLength) {
                    return validation.hasFailed(this.getFieldErrorMessage('fieldMaxLengthError'));
                }
    
                return validation.hasPassed();
            });

            this.addFieldValidation((validation) => {
                if (!("pattern" in validation)) {
                    return validation.hasPassed();
                }

                if (!validation.pattern) {
                    return validation.hasPassed();
                }

                const regex = new RegExp(validation.pattern, "i");

                if (!regex.test(this.userInput)) {
                    return validation.hasFailed(this.getFieldErrorMessage('patternMatchError'));
                }

                return validation.hasPassed();
            });
        }
    }
};